import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import alertReducer from "./alert-store";
import apiKeyReducer from "./api_key-store";
import templateReducer from "./template-store";
import campaignReducer from "./campaign-store";
import settingReducer from "./setting-store";
import personalizeReducer from "./pesonalize-store";
import landingpageReducer from "./landingpage-store";
import ezleadzReducer from "./ezleadz-store";

const store = new configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
    api_key: apiKeyReducer,
    template: templateReducer,
    campaign: campaignReducer,
    settings: settingReducer,
    personalize: personalizeReducer,
    landingpage: landingpageReducer,
    ezleadzStore: ezleadzReducer,
  },
});

//After every store element update return tree structure and single element like store.getState().alert
store.subscribe(() => {
  // console.log(store.getState().alert);
});

export default store;
